import config from '../../config/index'
import request from 'superagent'

interface IOpts {
  successCallback?: Function,
  errorCallback?: Function,
  token?: string
}

interface IInternals {
  get(route: String, opts?: IOpts),
  post(route: String, payload?: any, opts?: IOpts),
  put: Function,
  delete: Function,
}

const internals: IInternals = {
  get: (route: String, opts?: IOpts) => {

    request
      .get(config.pathGENEVA + route)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${opts && opts.token}`)
      .withCredentials()
      .end((err, res) => {
        if (!err && res.ok && opts.successCallback) {
          opts.successCallback(res.body)
        }
        else {
          if (opts.errorCallback && typeof opts.errorCallback === 'function') {
            opts.errorCallback(res && res.body)
          }
        }
      })
  },

  post: (route: String, payload?: any, opts?: IOpts) => {
    request
      .post(config.pathGENEVA + route)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${opts && opts.token}`)
      .send(payload)
      .withCredentials()
      .end((err, res) => {
        if (!err && res.ok && opts.successCallback) {
          opts.successCallback(res.body)
        }
        else {
          if (opts.errorCallback && typeof opts.errorCallback === 'function') {
            opts.errorCallback(res && res.body)
          }
        }
      })
  },
  put: (route: String, payload?: any, opts?: IOpts) => {
    request
      .put(config.pathGENEVA + route)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${opts && opts.token}`)
      .send(payload)
      .withCredentials()
      .end((err, res) => {
        if (!err && res.ok && opts.successCallback) {
          opts.successCallback(res.body)
        }
        else {
          if (opts.errorCallback && typeof opts.errorCallback === 'function') {
            opts.errorCallback(res && res.body)
          }
        }
      })
  },
  delete: (route: String, opts?: IOpts) => {
    request
      .del(config.pathGENEVA + route)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${opts && opts.token}`)
      .withCredentials()
      .end((err, res) => {
        if (!err && res.ok && opts.successCallback) {
          opts.successCallback(res.body)
        }
        else {
          if (opts.errorCallback && typeof opts.errorCallback === 'function') {
            opts.errorCallback(res && res.body)
          }
        }
      })
  },
}

export { internals as default }
